const ITEMS = [
  { zone: 'tight', color: 'bg-tight', label: 'Tighter fit', title: 'Tight', description: 'May feel snug or restrictive' },
  { zone: 'neutral', color: 'bg-neutral', label: 'Comfort / neutral fit', title: 'Comfort', description: 'Optimal fit and movement' },
  { zone: 'loose', color: 'bg-loose', label: 'Looser fit', title: 'Loose', description: 'May feel baggy or roomy' },
] as const;

interface Props {
  /** 'compact' (default) is a single-line inline key, used above result lists. 'detailed' is the two-line stacked version used in the Fit Profile panel. */
  variant?: 'compact' | 'detailed';
}

export function FitLegend({ variant = 'compact' }: Props) {
  if (variant === 'detailed') {
    return (
      <ul className="space-y-4" aria-label="Fit colour legend">
        {ITEMS.map((item) => (
          <li key={item.zone} className="flex items-start gap-3">
            <span aria-hidden className={`mt-1.5 h-3 w-3 shrink-0 rounded-full ${item.color}`} />
            <div>
              <p className="text-base font-semibold text-ink">{item.title}</p>
              <p className="text-sm text-muted">{item.description}</p>
            </div>
          </li>
        ))}
      </ul>
    );
  }

  return (
    <ul className="flex flex-wrap gap-4 text-sm text-ink" aria-label="Fit colour legend">
      {ITEMS.map((item) => (
        <li key={item.zone} className="flex items-center gap-2">
          <span aria-hidden className={`inline-block h-3 w-3 rounded-full ${item.color}`} />
          <span>{item.label}</span>
        </li>
      ))}
    </ul>
  );
}
